function useIdColorHash(id) {
  const MIN = 1;
  const MAX = 6;
  const charCodeSum = id.split("").reduce((sum, char) => {
    return sum + char.charCodeAt(0);
  }, 0);
  return charCodeSum % MAX + MIN;
}
export {
  useIdColorHash
};
//# sourceMappingURL=useIdColorHash.js.map
